type TokenCallback = () => void;

let listeners: TokenCallback[] = [];

export const subscribeToTokenRefresh = (cb: TokenCallback) => {
    listeners.push(cb);
};

export const notifyTokenRefreshed = () => {
    listeners.forEach((cb) => cb());
    listeners = [];
};
